import ActionTypes from '../constants/action-types';
import standardAction from '../../../utilities/standard-action';
import { RootActionTypes } from '../../../stores/types';

export default function showDeclineFraudReviewDialog(fraudId: string): RootActionTypes {
  return standardAction(ActionTypes.SHOW_DECLINE_FRAUD_REVIEW_DIALOG, { show: true, fraudId });
}
